// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { DatePickerTokens } from './type';

const datePickerTokens: DatePickerTokens = {
  datePickerFontSize: '14/regular',
  datePickerFontColor: 'Neutral-text-5',
  datePickerBorderRadius: 'Radius-4',
  datePickerBorderColor: 'Neutral-border-2',
  datePickerPaddingX: 'Padding-8',
  datePickerPaddingY: 'Padding-4',
  datePickerIconSize: 'Size-7',
  datePickerIconColor: 'Neutral-text-4',
  datePickerSmallFontSize: '12/regular',
  datePickerSmallPaddingX: 'Padding-8',
  datePickerSmallPaddingY: 'Padding-1',
  datePickerLargeFontSize: '16/regular',
  datePickerLargePaddingX: 'Padding-12',
  datePickerLargePaddingY: 'Padding-7',
  datePickerDateWidth: 'Size-120',
  datePickerDateRangeWidth: 'Size-140',
  datePickerDatetimeWidth: 'Size-120',
  datePickerDatetimeRangeWidth: 'Size-210',
  datePickerPlaceholderColor: 'Neutral-text-2',
  datePickerBackgroundColor: 'Neutral-fill-1',
  datePickerClearColor: 'Neutral-text-3',
  datePickerHoverBorderColor: 'Brand-6',
  datePickerHoverClearColor: 'Neutral-text-4',
  datePickerFocusBorderColor: 'Brand-7',
  datePickerFocusShadow: 'Brand-2',
  datePickerDisabledFontColor: 'Neutral-text-2',
  datePickerDisabledPlaceholderColor: 'Neutral-text-2',
  datePickerDisabledBorderColor: 'Neutral-border-1',
  datePickerDisabledBackgroundColor: 'Neutral-fill-2',
  datePickerResultTextBorderRadius: 'Radius-4',
  datePickerResultTextPaddingX: 'Padding-4',
  datePickerResultTextSmallPaddingX: 'Padding-4',
  datePickerResultTextLargePaddingX: 'Padding-10',
  datePickerResultTextActiveBackgroundColor: 'Brand-1',
  datePickerErrorBorderColor: 'Danger-6',
  datePickerErrorFocusShadow: 'Danger-1',
  datePickerPanelTitlePaddingTop: 'Padding-10',
  datePickerPanelTitleFontSize: '14/regular',
  datePickerPanelColor: 'Neutral-text-5',
  datePickerPanelBackgroundColor: 'Neutral-fill-1',
  datePickerPanelShadow: 'Shadow-2',
  datePickerPanelRadius: 'Radius-4',
  datePickerPanelMargin: 'Margin-24',
  datePickerPanelBorder: 'Neutral-border-1',
  datePickerPanelHeaderFontSize: '14/regular',
  datePickerPanelHeaderPaddingX: 'Padding-12',
  datePickerPanelHeaderPaddingY: 'Padding-8',
  datePickerPanelHeaderBorderColor: 'Neutral-border-1',
  datePickerPanelHeaderIconColor: 'Neutral-text-5',
  datePickerPanelHeaderIconWidth: 'Size-7',
  datePickerPanelHeaderIconHotWidth: 'Size-13',
  datePickerPanelHeaderIconHoverBackgroundColor: 'Neutral-fill-3',
  datePickerPanelHeaderTitlePaddingX: 'Padding-4',
  datePickerPanelBodyPaddingX: 'Padding-16',
  datePickerPanelBodyPaddingY: 'Padding-16',
  datePickerPanelBodyFontSize: '14/regular',
  datePickerPanelFooterPaddingX: 'Padding-16',
  datePickerPanelFooterPaddingY: 'Padding-10',
  datePickerPanelFooterLeftFontSize: '14/regular',
  datePickerPanelFooterRightFontSize: '14/regular',
  datePickerCellColor: 'Neutral-text-5',
  datePickerCellHotHeight: 'Size-12',
  datePickerCellHeight: 'Size-16',
  datePickerCellHoverColor: 'Neutral-text-5',
  datePickerCellHoverBackgroundColor: 'Neutral-fill-3',
  datePickerCellActiveColor: 'Neutral-text-1',
  datePickerCellActiveBackgroundColor: 'Brand-6',
  datePickerCellActiveHoverBackgroundColor: 'Brand-2',
  datePickerCellDisabledColor: 'Neutral-text-2',
  datePickerCellDisabledBackgroundColor: 'Neutral-fill-2',
  datePickerCellRangeBackgroundColor: 'Brand-1',
  datePickerCellOtherColor: 'Neutral-text-2',
  datePickerCellHeaderColor: 'Neutral-text-4',
  datePickerCellMarginY: 'Margin-4',
  datePickerDayPanelWidth: 'Size-124',
  datePickerWeekPanelWidth: 'Size-142',
  datePickerYearPanelWidth: 'Size-124',
  datePickerYearCellHotWidth: 'Size-32',
  datePickerMonthPanelWidth: 'Size-124',
  datePickerMonthCellHotWidth: 'Size-32',
  datePickerQuarterPanelWidth: 'Size-124',
  datePickerQuarterCellHotWidth: 'Size-28',
  datePickerTimePanelWidth: 'Size-115',
  datePickerTimePanelPaddingX: 'Padding-12',
  datePickerTimePanelPaddingY: 'Padding-7',
  datePickerTimeListGap: 'Margin-8',
  datePickerTimeItemHeight: 'Size-15',
  datePickerTimeItemBorderRadius: 'Radius-4',
  datePickerTimeItemPaddingY: '2px',
  datePickerTimeItemBackgroundColor: 'Neutral-fill-1',
  datePickerTimeItemColor: 'Neutral-text-5',
  datePickerTimeItemActiveBackgroundColor: 'Brand-1',
  datePickerTimeItemActiveColor: 'Brand-6',
  datePickerTimeItemDisabledColor: 'Neutral-text-2',
  datePickerTimeItemHoverBackgroundColor: 'Neutral-fill-2',
  datePickerQuickPanelPaddingX: 'Padding-8',
  datePickerQuickPanelPaddingY: 'Padding-12',
  datePickerQuickPanelGap: 'Margin-8',
  datePickerQuickPanelItemFontSize: '12/regular',
  datePickerQuickPanelItemPaddingX: 'Padding-12',
  datePickerQuickPanelItemPaddingY: 'Padding-2',
  datePickerQuickPanelItemHoverBackgroundColor: 'Neutral-fill-2',
};

export default datePickerTokens;
